export default __webpack_public_path__ + "static/media/AtheneumPrivacyPolicyNotice_2022July.dec413d6.pdf";